import { redirect, RedirectOptions, ROUTE_NAMES } from '$router/config'
import { useMount } from 'ahooks'

type Props = {
  to: ROUTE_NAMES
  options?: RedirectOptions
}

const Navigate = ({ to, options }: Props) => {
  useMount(() => {
    redirect(to, options)
  })

  return null
}

export default Navigate
